module.exports = __webpack_public_path__ + "static/img/ga-tag-manager.ee63efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/ga-tag-manager.png
// module id = f+Jh
// module chunks = 6